// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "TwoColumnHeroWithImageLeft-module--backgroundContainmentImage--ad3eb";
export var elevatedContainmentImage = "TwoColumnHeroWithImageLeft-module--elevatedContainmentImage--3bb99";
export var innerImage = "TwoColumnHeroWithImageLeft-module--innerImage--a2714";
export var innerWrapper = "TwoColumnHeroWithImageLeft-module--innerWrapper--6014b";
export var normalContainmentImage = "TwoColumnHeroWithImageLeft-module--normalContainmentImage--af087";